import { useNavigate } from 'react-router-dom'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { useOnboarding } from 'modules/project_management/contexts/onboardingContext'

import ProjectsLandingPageContent from './ProjectsLandingContent'

const ProjectsOnboardingPage = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const onboardingContext = useOnboarding()

  useEffect(() => {
    track(trackingEvents.projectManagement.onboarding.showOnboarding)
  }, [])

  const onButtonClick = async () => {
    await track(trackingEvents.projectManagement.onboarding.clickLetsGetStarted)
    onboardingContext?.setShowOnboarding(false)
    navigate(navigation.projects.list.fullPath())
  }

  return <ProjectsLandingPageContent onButtonClick={onButtonClick} />
}

export default ProjectsOnboardingPage
